import { useSyncExternalStore } from "react";
import api from "@/lib/api";
import { toast } from "@/lib/toast";

/** iter398 C — échanges en deux temps : (1) fenêtre « Objet » avant l'action → enregistrement immédiat « en cours » ;
 * (2) au retour dans Le Desk, fenêtre « Retour » (statut, commentaire, date de rappel) → « terminé ». Fermer sans répondre = reste « en cours ». */
let state = { ask: null, ret: null }; // ask: { contact, channel, target, go } · ret: exchange en attente de retour
const subs = new Set();
const emit = () => subs.forEach((f) => f());
const set = (p) => { state = { ...state, ...p }; emit(); };
const listeners = new Set();
export const onExchangeChange = (f) => { listeners.add(f); return () => listeners.delete(f); };
const changed = () => { listeners.forEach((f) => f()); window.dispatchEvent(new Event("ledesk:exchanges-changed")); };

export const useExchangeStore = () => useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => state);

/** Lance un échange : ouvre la fenêtre « Objet ». `go()` est exécuté après l'enregistrement. Sans contact (numéro orphelin) → action directe. */
export const startExchange = ({ contact, channel, target, go }) => (contact?.id ? set({ ask: { contact, channel, target, go } }) : go?.());
export const cancelAsk = () => set({ ask: null });

export async function confirmAsk(subject) {
  const a = state.ask;
  if (!a) return;
  try {
    const { data } = await api.post("/crm/exchanges", { contact_id: a.contact.id, channel: a.channel, target: a.target, subject });
    set({ ask: null });
    changed();
    a.go?.();
    armReturn(data);
  } catch (e) { toast.error(e?.response?.data?.detail || "Enregistrement impossible"); }
}

/** Au retour (focus) ou après 1,5 s : la fenêtre « Retour » s'ouvre pour cet échange. */
function armReturn(x) {
  let done = false;
  const fire = () => { if (done) return; done = true; window.removeEventListener("focus", fire); set({ ret: x }); };
  window.addEventListener("focus", fire);
  setTimeout(fire, 1500);
}

export const resumeExchange = (x) => set({ ret: x });
export const dismissReturn = () => set({ ret: null }); // reste « en cours »

export async function closeExchange(payload) {
  const x = state.ret;
  if (!x) return;
  try {
    await api.post(`/crm/exchanges/${x.id}/close`, payload);
    set({ ret: null });
    toast.success("Retour enregistré");
    changed();
  } catch (e) { toast.error(e?.response?.data?.detail || "Enregistrement impossible"); }
}
